import React, { FC, useEffect } from 'react';
import TableSimple from 'src/components/TableSimple';
import { TableColumnType } from 'src/types/table';
import translate from '@translate';
import Dialog from 'src/components/Dialog';
import { ZasilkovnaCarrierType } from 'src/types/zasilkovna';

const allColumns: TableColumnType[] = [
    {
        label: 'label',
        key: 'label',
    },
    {
        label: 'value',
        key: 'value',
    },
];

export interface CarriersTablePropsType {
    onClose: () => void;
    getCarriers: () => void;
    dataCarriers: ZasilkovnaCarrierType[] | null;
    loading?: boolean;
}

const CarriersTable: FC<CarriersTablePropsType> = (props) => {
    useEffect(() => {
        if (!props.dataCarriers) {
            props.getCarriers();
        }
    }, [props.dataCarriers]);

    return (
        <Dialog onClose={props.onClose} maxWidth="lg" title={translate('ordersImport.carriers.title')}>
            <TableSimple
                rowIdKey="value"
                rows={props.dataCarriers || []}
                columsLabelPrefix="ordersImport.carriers.table"
                allColumns={allColumns}
                initSort={{ column: 'label', direction: 'DESC' }}
                loading={props.loading}
                showInModal
            />
        </Dialog>
    );
};

export default CarriersTable;
